import { type FC } from 'react';

import { ContactsButtonRenderer } from './CardContactsButtonRenderer';

export const CardContactsButtonMobileContainer: FC = () => {
  return <ContactsButtonRenderer />;
};
